<host-calendar
  class="month-calendar"
  [showYear]="_currentYear"
  [showMonth]="_currentMonth"
  [showPicker]="false"
  [weekLines]="6"
  (monthChange)="monthChange.emit($event)"
>
  <ng-template #header let-listOfWeekName>
    <div
      class="column-header border-b border-r last:border-r-0 border-solid border-[#E2E5E9] text-[#34383c] text-[14px] text-center"
      [class.weekend]="i === 5 || i === 6"
      *ngFor="let day of listOfWeekName; let i = index"
    >
      {{ day }}
    </div>
  </ng-template>
  <ng-template #cell let-day>
    <div class="cell-wrapper relative">
      <div
        *ngIf="!day.isLastMonth && !day.isNextMonth"
        class="cell-body bg-[length:100%_100%]"
        [ngClass]="{
          'selected-head': isHead(day.date),
          'selected-last': isLast(day.date),
          selected: isBetween(day.date),
          'bg-[url(/assets/calendar/shadow.png)]': [0, -1, -3].indexOf(calendarMap[day.title]?.available) !== -1,
          'bg-[#f9f9f9]': calendarMap[day.title]?.available === -2
        }"
        (click)="toggleSelecting(day)"
        (mouseover)="updateSelectedDates(day)"
      >
        <!-- <span
          class="price"
          *ngIf="displayPrice">
          {{ price(day)?.currency_type}} {{ price(day)?.price }}
        </span> -->
        <span
          class="date"
          [class.weekend]="day.dayOfWeek === 5 || day.dayOfWeek === 6"
          [class.today]="day.isCurrentDay"
          [class.holiday]="day.holidayName"
        >
          {{
          day.isCurrentDay ? ("word.today" | translate) : isInternational ? day.number : day.holidayName || day.number
          }}
        </span>
        <span class="rest-token" [class.work]="day.isOff"
              *ngIf="day.isLegalHoliday || day.isOff">
          {{ (day.isLegalHoliday ? "word.rest" : "word.work") | translate }}
          <!-- 休 -->
        </span>

        <!-- 状态图标 -->
        <div class="status-icons">
          <img
            nz-popover
            nzTrigger="hover"
            [nzPopoverTitle]="'component.multi_house_calendar.note_title' | translate"
            [nzPopoverContent]="notePopTpl"
            class="status-icon"
            src="/assets/calendar/note.png"
            *ngIf="calendarMap[day.title]?.note"
          />

          <!-- 房态不一致 -->
          <img
            nz-popover
            nzTrigger="hover"
            [nzPopoverTitle]="''"
            [nzPopoverContent]="exclamationPopTpl"
            class="status-icon"
            src="/assets/calendar/inconsistent.png"
            *ngIf="calendarMap[day.title]?.available === -1"
          />

          <!-- 小时单 -->
          <img
            class="status-icon"
            [src]="
              isHourReservationSelected(day.title)
                ? '/assets/icon/icon_hour_reservation_selected.png'
                : '/assets/icon/icon_hour_reservation.png'
            "
            *ngIf="hourReservationMap[day.title]?.length"
            (click)="onClickHourOrder($event, day.title)"
          />

          <!-- task -->
          <img
            *ngIf="taskMap[day.title]?.length"
            class="status-icon"
            src="/assets/icon/icon_task.png"
            (click)="onClickTasks($event, taskMap[day.title])"
          />

          <!-- 停用 -->
          <img
            *ngIf="calendarMap[day.title]?.available === -3"
            class="status-icon"
            src="/assets/icon/icon_forbidden.png"
            alt=""
          />
        </div>

        <!-- 规则图标 -->
        <div
          class="rules-icons"
          nz-popover
          [nzPopoverTitle]="null"
          [nzPopoverContent]="rulePopTpl"
          *ngIf="showLeadRules && calendarMap[day.title]?.prices?.[0]?.setting"
        >
          <div class="rules-item"
               *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.showMoon">
            <img class="rules-icon" src="/assets/v4/icon-calendar-moon.svg"
                 alt=""/>
            <span
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.moonCount"
              class="text-[10px] text-[#586167]">{{
              calendarMap[day.title]?.prices?.[0]?.setting?.moonCount
              }}</span>
          </div>
          <div class="rules-item"
               *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.showLock">
            <img class="rules-icon" src="/assets/v4/icon-calendar-lock.svg"
                 alt=""/>
          </div>
          <div class="rules-item"
               *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.showFlag">
            <img class="rules-icon" src="/assets/v4/icon-calendar-flag.svg"
                 alt=""/>
          </div>
        </div>

        <!-- 价格 -->
        <div class="price" *ngIf="showLeadPrice">
          {{ calendarMap[day.title]?.prices?.[0]?.price }}
        </div>

        <!-- 操作气泡  -->

        <div
          nz-popover
          [nzPopoverTitle]="null"
          [nzPopoverContent]="operatePop"
          [nzPopoverTrigger]="null"
          [nzPopoverPlacement]="'top'"
          [nzPopoverVisible]="displaySelectPop && selectStatus === 'done' && isLast(day.date)"
          [nzPopoverOverlayClassName]="'month-calendar-v2'"
        ></div>

        <ng-template #operatePop>
          <div
            class="flex flex-row items-center divide-x divide-[#a2a2a2] divide-solid">
            <!-- 录入订单 -->
            <div class="item text-c-d2"
                 (click)="changeTab('manual-order', $event)">
              {{ "calendar.pop.add_order" | translate }}
            </div>

            <!-- 小时单 -->
            <div
              class="item text-c-d2"
              *ngIf="isLast(day.date) && isHead(day.date)"
              (click)="displayHourReservationPanel(day.title, $event)"
            >
              {{ "calendar.pop.hour_reservation" | translate }}
            </div>
            <ng-container *ngIf="dataOfSelectedDates.status !== 'past'">
              <div
                class="item text-c-d2"
                (click)="changeHouseAvailable(1, $event)"
                *ngIf="dataOfSelectedDates.status === 'diff' || dataOfSelectedDates.status === 'close'"
              >
                {{ "calendar.pop.status_on" | translate }}
                <!-- 打开 -->
              </div>

              <div
                class="item text-c-d2"
                (click)="changeHouseAvailable(0, $event)"
                *ngIf="dataOfSelectedDates.status === 'diff' || dataOfSelectedDates.status === 'open'"
              >
                {{ "calendar.pop.status_off" | translate }}
                <!-- 关闭 -->
              </div>

              <div class="item text-c-d2" (click)="displayEditNotePop = true">
                {{ "calendar.pop.add_note" | translate }}
                <!-- 备注 -->
              </div>

              <!-- 任务  -->
              <div
                *ngIf="isLast(day.date) && isHead(day.date)"
                class="item text-c-d2"
                (click)="onCreateTask($event, day.title)"
              >
                {{ "calendar.pop.new_task" | translate }}
              </div>
            </ng-container>
          </div>
        </ng-template>

        <!-- 编辑备注   -->
        <div
          nz-popover
          [nzPopoverTitle]="null"
          [nzPopoverTrigger]="null"
          [nzPopoverContent]="editNotePop"
          [nzPopoverPlacement]="'left'"
          [nzPopoverVisible]="displayEditNotePop && isLast(day.date)"
        ></div>

        <!-- 编辑备注模板 -->
        <ng-template #editNotePop>
          <host-auto-popover
            type="note-edit"
            [noteText]="dataOfEditNotePop.text"
            (onClickConfirmEditNote)="onSaveEditNote($event)"
            (onClickCancelEditNote)="onCancelEditNote()"
          ></host-auto-popover>
        </ng-template>

        <ng-template #rulePopTpl>
          <div>
            <!-- 月亮 -->
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.min_stay_on_arrival">
              {{ "calendar-rules_min_stay_on_arrival" | translate }}
              <!-- Min stay on arrival: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.min_stay_on_arrival }}
            </div>
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.min_stay_through">
              {{ "calendar-rules_min_stay_through" | translate }}
              <!-- Min stay through: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.min_stay_through }}
            </div>
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.max_stay_on_arrival">
              {{ "calendar-rules_max_stay_on_arrival" | translate }}
              <!-- Max stay on arrival: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.max_stay_on_arrival }}
            </div>
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.max_stay_through">
              {{ "calendar-rules_max_stay_through" | translate }}
              <!-- Max stay through: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.max_stay_through }}
            </div>
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.exact_stay_on_arrival">
              {{ "calendar-rules_exact_stay_on_arrival" | translate }}
              <!-- Exact stay on arrival: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.exact_stay_on_arrival }}
            </div>

            <!-- 锁 -->
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.closed_on_arrival">
              {{ "calendar-rules_closed_on_arrival" | translate }}
              <!-- Closed on arrival: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.closed_on_arrival ? "Enabled" : "Disabled" }}
            </div>
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.closed_on_departure">
              {{ "calendar-rules_closed_on_departure" | translate }}
              <!-- Closed on departure: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.closed_on_departure ? "Enabled" : "Disabled" }}
            </div>

            <!-- 旗子  -->
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.min_advance_res">
              {{ "calendar-rules_min_advance_res" | translate }}
              <!-- Min advance res: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.min_advance_res }}
            </div>
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.max_advance_res">
              {{ "calendar-rules_max_advance_res" | translate }}
              <!-- Max advance res: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.max_advance_res }}
            </div>
            <div
              *ngIf="calendarMap[day.title]?.prices?.[0]?.setting?.seasonal_rule">
              {{ "calendar-rules_seasonal_rule" | translate }}
              <!-- Seasonal rule: -->
              {{ calendarMap[day.title]?.prices?.[0]?.setting?.seasonal_rule }}
            </div>
          </div>
        </ng-template>

        <ng-template #notePopTpl>
          <div class="note-pop-container">
            <span
              class="note-pop-text">{{ calendarMap[day.title]?.note }}</span>
          </div>
        </ng-template>
        <ng-template #exclamationPopTitleTpl>
          <div class="exclamation-pop-title">
            <span class="title">
              {{ "component.month_calendar_v2.have_unclosed_channel" | translate }}
              <!-- 有未关房渠道 -->
            </span>
            <span class="tip">
              <!-- {{ "component.month_calendar_v2.click_date_to_change_house_status" | translate }} -->
              <!-- 点击日期可修改房态 -->
            </span>
          </div>
        </ng-template>
        <ng-template #exclamationPopTpl>
          <host-auto-popover
            type="status-diff"
            [statusDiffList]="{
              '0': calendarMap[day.title]?.closed_thirdparty,
              '1': calendarMap[day.title]?.open_thirdparty
            }"
          ></host-auto-popover>
        </ng-template>

        <div
          class="reservation-bar"
          [class.selected]="calendarMap[day.title]?.resv?.code === selectedReservationCode"
          [class.head]="calendarMap[day.title]?.resvHead"
          [class.last]="calendarMap[day.title]?.resvLast"
          [style.background-color]="getReservationColor(calendarMap[day.title])"
          *ngIf="calendarMap[day.title]?.resv"
          (click)="onClickReservation(calendarMap[day.title]?.reservation)"
          nz-popover
          [nzPopoverTitle]="null"
          [nzPopoverTrigger]="null"
          [nzPopoverContent]="resvOptPop"
          [nzPopoverVisible]="
            resvPopRefreshFlag &&
            calendarMap[day.title]?.resvHead &&
            calendarMap[day.title]?.resv?.code === selectedReservationCode
          "
          [nzPopoverOverlayClassName]="'month-calendar-v2'"
        >
          <ng-container *ngIf="calendarMap[day.title]?.resvHead">
            <div class="overflow-hidden">
              <div class="name">
                {{ calendarMap[day.title]?.resv?.client?.name }}
              </div>
              <div class="info">
                <span class="platform">
                  {{ getChannelName(calendarMap[day.title]?.resv) }}
                </span>
                <span class="nights">
                  {{ calendarMap[day.title]?.resvNights }}{{ "word.plural.night" | translate }}
                </span>
              </div>
            </div>
          </ng-container>
          <ng-container *ngIf="calendarMap[day.title]?.resvLast">
            <img
              class="owe"
              hostI18nImageSwitcher
              [urls]="['/assets/calendar/owe.png', '/assets/calendar/owe_en.png']"
              *ngIf="calendarMap[day.title]?.resv?.settlement_status === 1"
            />
            <!-- <div
              class="owe"
              *ngIf="calendarMap[day.title]?.__reservation?.settlement_status === 1"></div> -->
            <img
              *ngIf="calendarMap[day.title]?.resv?.reservation_tag?.length"
              src="/assets/calendar/tag.png"
              class="tag"
            />
          </ng-container>
        </div>

        <ng-template #resvOptPop>
          <div
            class="flex flex-row items-center divide-x divide-[#a2a2a2] divide-solid">
            <div class="item text-c-d2"
                 (click)="onExtendStay(calendarMap[day.title]?.resv?.code)">
              {{ "calendar.pop.extend_stay" | translate }}
            </div>
            <div class="item text-c-d2"
                 (click)="onCreateTask($event, calendarMap[day.title]?.resv?.check_in)">
              {{ "calendar.pop.new_task" | translate }}
            </div>
          </div>
        </ng-template>
      </div>
    </div>
  </ng-template>
</host-calendar>
